import React, { Component } from 'react';
import classNames from 'classnames';

import './dpit-anim-rb-builder.scss';

export default class RunningBulletsAnim extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentIdx: -1,
		};
		this.interval = null;
	}

	componentDidUpdate() {
		if (!this.interval && this.props.active) {
			this.interval = setInterval(() => {
				let nextIdx = (!this.props.reverse) ? this.state.currentIdx + 1 : this.state.currentIdx - 1;
				if (nextIdx < -this.props.count) nextIdx = 2 * this.props.count;
				if (nextIdx > 2 * this.props.count) nextIdx = -this.props.count;
				this.setState({ currentIdx: nextIdx });
			}, this.props.clockPeriodMs);
		} else if (!this.props.active && this.interval) {
			clearInterval(this.interval);
			this.interval = null;
			this.setState({ currentIdx: -1 });
		}
	}

	render() {
		const bullets = [];
		const currentIdx = this.state.currentIdx;
		for (let i = 0; i < this.props.count; i++) {
			const bulletClasses = classNames({
				[`${this.props.classBEMRoot}__item`]: true,
				'dpit-bullet-on': i === currentIdx,
				'dpit-bullet-on--1': i === currentIdx - 1 || i === currentIdx + 1,
				'dpit-bullet-on--2': i === currentIdx - 2 || i === currentIdx + 2
			});
			bullets[i] = (
				<li key={i} className={bulletClasses} />
			);
		}
		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
			active: this.props.active,
		});
		return (
			<div className={mainClasses}>
				<ul>
					{bullets}
				</ul>
			</div>
		);
	}
}
